import { useTranslation } from 'react-i18next';
import styles from './style.module.css';

export const Save = ({onPress , changedData}) => {
        const { t, i18n } = useTranslation();
    
    return <span onClick={()=>{onPress()}} className={styles.Save + " "+ (changedData && styles.SaveActive)}>{t("save")}</span>

};




